import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';

import { store, persistor } from './store/index';
import { closeFileViewer } from './actions';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import LogRocket from 'logrocket';
import applyTheme from './utils/applyTheme';

LogRocket.init(process.env.REACT_APP_LOGROCKET_ID);

// Apply per-client brand theme to CSS variables before the first paint.
applyTheme();

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate
      persistor={persistor}
      onBeforeLift={() => store.dispatch(closeFileViewer())}
    >
      <App />
    </PersistGate>
  </Provider>
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
